import { createApi } from '@reduxjs/toolkit/query/react';
import {
  ContactSentimentDetailDto,
  ContactSentimentDto,
  FindAllContactSentimentsByChatDto,
  FindAllContactSentimentsDto,
  FindOneContactSentimentByChatDto,
  FindOneContactSentimentDto,
  ResponseDto,
  ResponsePagingDto
} from 'types';
import axiosBaseQuery from 'utils/base-api';

export const contactSentimentsApi = createApi({
  reducerPath: 'contactSentimentsApi',
  tagTypes: [
    'contact_sentiments',
    'contact_sentiment',
    'contact_sentiments_detail',
    'contact_sentiments_by_chat',
    'contact_sentiment_by_chat'
  ],
  baseQuery: axiosBaseQuery,
  endpoints: (builder) => ({
    findAllContactSentiments: builder.query<ResponsePagingDto<ContactSentimentDto>, FindAllContactSentimentsDto>({
      query: (payload) => ({
        url: '/contact_sentiments/find_multiple',
        method: 'post',
        data: payload,
        _ignoreNotificationError: true
      }),
      providesTags: (result) =>
        result && Array.isArray(result.data.rows) && result.data.rows.length > 0
          ? result.data.rows.map(({ idNumber }) => ({
              type: 'contact_sentiments',
              id: idNumber
            }))
          : ['contact_sentiments']
    }),

    findOneContactSentiment: builder.query<ResponseDto<ContactSentimentDto>, FindOneContactSentimentDto>({
      query: (payload) => ({
        url: `/contact_sentiments/find_one`,
        method: 'post',
        data: payload,
        _ignoreNotificationError: true
      }),
      providesTags: (result) => (result?.data ? [{ type: 'contact_sentiment', id: result.data.idNumber }] : [])
    }),

    findDetailContactSentiment: builder.query<ResponseDto<ContactSentimentDetailDto>, FindOneContactSentimentDto>({
      query: (payload) => ({
        url: `/contact_sentiments/find_detail`,
        method: 'post',
        data: payload,
        _ignoreNotificationError: true
      }),
      providesTags: (result) => (result?.data ? [{ type: 'contact_sentiments', id: result.data.idNumber }] : [])
    }),

    findAllContactSentimentsByChatId: builder.query<
      ResponsePagingDto<ContactSentimentDto>,
      FindAllContactSentimentsByChatDto
    >({
      query: (payload) => ({
        url: '/contact_sentiments/find_multiple_by_chat_id',
        method: 'post',
        data: payload,
        _ignoreNotificationError: true
      }),
      providesTags: (result) =>
        result && Array.isArray(result.data.rows) && result.data.rows.length > 0
          ? result.data.rows.map(({ idNumber }) => ({
              type: 'contact_sentiments_by_chat',
              id: idNumber
            }))
          : ['contact_sentiments_by_chat']
    }),

    findOneContactSentimentByChatId: builder.query<ResponseDto<ContactSentimentDto>, FindOneContactSentimentByChatDto>({
      query: (payload) => ({
        url: `/contact_sentiments/find_one_by_chat_id`,
        method: 'post',
        data: payload,
        _ignoreNotificationError: true
      }),
      providesTags: (result) => (result?.data ? [{ type: 'contact_sentiment_by_chat', id: result.data.idNumber }] : [])
    })
  })
});

export const {
  useFindAllContactSentimentsQuery,
  useFindOneContactSentimentQuery,
  useFindDetailContactSentimentQuery,
  useFindAllContactSentimentsByChatIdQuery,
  useFindOneContactSentimentByChatIdQuery
} = contactSentimentsApi;
